import { environment } from 'src/environments/environment';
/***
 * Apponfig Interface
 */
interface IAppConfig {
  apiEndpoint: string;
  appName: string;
  appLanguage: string;
  fevicon?: '';
}

/**
 * Appconfig const fiile
 */
export const AppConfig: IAppConfig = {
  apiEndpoint: environment.apiUrl,
  appName: 'RAD Development',
  appLanguage: 'EN',
  fevicon: '',
};
